import script from "./AccountsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountsDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AccountsDialog.vue?vue&type=style&index=0&id=e3ba3a0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3ba3a0c"]])

export default __exports__